// Centralized logger wrapper so we can control where errors go (console, remote telemetry, etc.)
// Keep very small and resilient so it can be imported from many places.

export function logError(...args: any[]) {
  try {
    // In production you might forward to telemetry here
    // e.g., window.__sendTelemetry?.('error', args)
    // Keep console output for local debugging but allow easy replacement.
    console.error(...args);
  } catch {
    // swallow
  }
}

export function logWarn(...args: any[]) {
  try {
    console.warn(...args);
  } catch {}
}

export function logInfo(...args: any[]) {
  try {
    console.info(...args);
  } catch {}
}
